export function addCurrent(satisfactionsurvey) {
    return {
        type: 'ADD_CURRENT',
        satisfactionsurvey,
    }
}
